export default "__VITE_ASSET__26f465a1__"